<template>
  <div  class="ExportCqxkzHome">
    <div class="contentCss" style="float: left;width:300px;">
      <el-tree
        style="margin-top:20px;"
        lazy
        check-strictly
        ref="xzqhTree"
        show-checkbox
        node-key="value"
        :default-expanded-keys="[activeNodeId]"
        :default-checked-keys="[activeNodeId]"
        :props="props"
        :load="loadNode"
        check-on-click-node
        @check-change="handleCheckChange"
      >
      </el-tree>
    </div>
    <div class="contentCss" style="display: inline-block;width: calc(100% - 340px);">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="width: calc(100% - 150px)"
            :model="formInline"
            label-position="left"
            label-width="100px"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="申请日期:">
                  <el-col :span="10">
                    <el-date-picker
                      v-model="formInline.beginTime"
                      type="date"
                      style="width: 100%"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                    />
                  </el-col>
                  <el-col style="text-align: center" class="line" :span="3">-</el-col>
                  <el-col :span="10">
                    <el-date-picker
                      v-model="formInline.endTime"
                      type="date"
                      style="width: 100%"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                    />
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="审批日期:">
                  <el-col :span="10">
                    <el-date-picker
                      v-model="formInline.hfbeginTime"
                      type="date"
                      style="width: 100%"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                    />
                  </el-col>
                  <el-col style="text-align: center" class="line" :span="3">-</el-col>
                  <el-col :span="10">
                    <el-date-picker
                      v-model="formInline.hfendTime"
                      type="date"
                      style="width: 100%"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                    />
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="行政层级(超期率):" label-width="130px">
                  <el-select v-model="formInline.childFlag" filterable placeholder="请选择">
                    <el-option
                      v-for="item in childFlagList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="化学品类别:">
                  <el-select v-model="formInline.hxplb" clearable placeholder="请选择">
                    <el-option
                      v-for="item in hxpLbList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="width: 150px">
            <el-button
              icon="el-icon-refresh-left"
              style="width: 80px; height: 39px;"
              round
              size="small"
              @click="resetDataSource"
            >重置</el-button>
          </div>
        </div>
      </div>
      <div style="color: #ff5721;">Tips：统计全国数据时会使用缓存，时效1小时；若导出失败，可等5分钟再导出;</div>
      <div style="margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;">
        <div class="tablemes">
          <el-button
            type="primary"
            icon="el-icon-upload2"
            round
            size="small"
            @click="dcGmzExcel()"
          >导出购买证</el-button>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            round
            size="small"
            @click="dcYszExcel()"
          >导出运输证</el-button>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            round
            size="small"
            @click="dcXkzCqlExcel()"
          >导出许可证超期率</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {exportGmzExcel, exportYszExcel, exportXkzCqlExcel} from "@/assets/js/sysgakh";
  import {getXzqTree, getXzqTreeS} from "@/assets/js/SplcPzym";

export default {
  name:'ExportCqxkz',
  data(){
    return {
      props: {
        label: "label",
        key: "value",
        isLeaf: (data, node) => {
          return !data.leaf;
        },
      },
      childFlagList: [
        {
          label:"所有子级",
          value:"all"
        },
        {
          label:"仅直接子级",
          value:"one"
        },
        ],
      hxpLbList: [
        {
          label:"一类",
          value:"100"
        },
        {
          label:"二类",
          value:"200"
        },
        {
          label:"三类",
          value:"300"
        },
        ],
      activeNodeId: 0, //当前选中区域Id
      activeLevel: "-1", //当前选中区域level
      formInline: { // 搜索表单
        beginTime: '',
        endTime: '',
        hfbeginTime: '',
        hfendTime: '',
        hxplb:'',
        childFlag:'all',
      },
    }
  },
  mounted() {
  },
  methods:{
    loadNode(node, resolve) {
      if (node.level == 0) {
        getXzqTree().then((res) => {
          resolve([res.data.data]);
        });
      }
      if (node.level > 0) {
        if (node.data.isReq) {
          getXzqTreeS(node.data.value).then((res) => {
            resolve(res.data.data);
          });
        } else {
          return resolve(node.data.children);
        }
        return resolve([]); // 加上这个，防止在该节点没有子节点时一直转圈的问题发生。
      }
    },
    handleCheckChange(data, checked, node) {
      if (checked) {
        //实现单选功能
        this.activeNodeId = data.value;
        this.activeLevel = data.level;
        this.$refs.xzqhTree.setCheckedKeys([]);
        this.$refs.xzqhTree.setCheckedKeys([data.value]);
      }
    },
    // 重置
    resetDataSource() {
      this.formInline = {
        beginTime: '',
        endTime: '',
        hfbeginTime: '',
        hfendTime: '',
        hxplb: '',
        childFlag:'all'
      }
    },
    //导出购买证
    dcGmzExcel() {
      this.$message.info("正在导出中...")
      exportGmzExcel(this.formInline,this.activeLevel,this.activeNodeId)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '购买证超期数据'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },
    //导出运输证
    dcYszExcel() {
      this.$message.info("正在导出中...")
      exportYszExcel(this.formInline,this.activeLevel,this.activeNodeId)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '运输证超期数据'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },
    //导出许可证超期率
    dcXkzCqlExcel() {
      this.$message.info("正在导出中...")
      exportXkzCqlExcel(this.formInline,this.activeLevel,this.activeNodeId)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '许可证超期率'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },
  }
}
</script>

<style scoped lang='less'>
  .ExportCqxkzHome {
    // height: 100%;
    // width: 90%;
    // background-color: white;
    // margin: auto;
    .headerSearch {
      padding: 30px 0 10px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 10px;
      }
    }
    .contentCss{
      height:825px;
      background-color: white;
      margin: 20px 20px 0px 0px;
      overflow-y: auto;
    }
    .sousuo {
      width: 95%;
      margin-left: auto;
      margin-right: auto;
      display: inline-flex;
      .sousuoButton {
        width: 90px;
        height: 39px;
        background: #4170ff;
        border-color: #4170ff;
      }
      .chongzhiButton {
        width: 90px;
        height: 39px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
